import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller(
            'CompanyConfigurationExporterController',
            CompanyConfigurationExporterController
        );

    function CompanyConfigurationExporterController(
        IssueExporterFactory,
        toastr
    ) {
        var vm = this;

        init();

        function init() {
            vm.save = save;

            getConfiguration();
        }

        function getConfiguration() {
            IssueExporterFactory.get().then(function (response) {
                vm.options = response.data.exportable_fields.map(function (
                    item
                ) {
                    item.name = item.column_title;
                    return item;
                });

                var selected = [];
                response.data.exported_fields.forEach(function (item) {
                    var result = response.data.exportable_fields.find(function (
                        obj
                    ) {
                        return obj.field_name === item;
                    });
                    if (result !== undefined) {
                        selected.push(result);
                    }
                });
                vm.selected = selected;
            });
        }

        function save() {
            IssueExporterFactory.update({
                exported_fields: vm.selected.map(function (item) {
                    return item.field_name;
                }),
            }).then(function () {
                toastr.success('Zapisano.');
            });
        }
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/company_configuration/exporter/exporter.controller.ts